import React from "react";
import _ from "lodash";
import TextAreaWithJsonCheck from "components/common/TextAreaWithJsonCheck";
import ClickToCopyWrapper from "components/common/ClickToCopyWrapper";

const DEFAULT_ALGO = [
  {
    name: "vote_highest_with_request aggregate 24 hr, sample each 24 hr",
    algorithm: "vote_highest_with_request",
    params: {
      aggregate_time_span: 24,
      sample_time_step: 24,
      ref_time_range: 72,
    },
  },
];

class CstAlgorithmsControl extends React.PureComponent {
  constructor(props) {
    super(props);

    let items = this.props.inputValue;
    let errorMsg = null;

    if (typeof items === "object" && !_.isEmpty(items)) {
      items = JSON.stringify(items);
    }

    this.state = {
      items,
      errorMsg,
    };

    this.handleItemsChanged = this.handleItemsChanged.bind(this);
  }

  handleItemsChanged(items) {
    this.setState({ items, errorMsg: null });

    if (_.isEmpty(items)) {
      this.setState({
        errorMsg: "Cannot be empty",
      });
      this.props.handleHasError(true);
      return;
    }

    try {
      const value = JSON.parse(items);

      if (!_.isArray(value)) {
        this.setState({
          errorMsg: `Should be an array of objects like the sample above`,
        });
        this.props.handleHasError(true);
        return;
      }

      if (_.isArray(value)) {
        if (_.isEmpty(value)) {
          this.setState({
            errorMsg: `Should be an array of objects like the sample above`,
          });
          this.props.handleHasError(true);
          return;
        }

        for (const p of value) {
          if (
            !_.get(p, "name") ||
            !_.get(p, "algorithm") ||
            !_.get(p, "params")
          ) {
            this.setState({
              errorMsg: `Should be an array of objects (check the sample above for examples)`,
            });
            this.props.handleHasError(true);
            return;
          }
        }
      }
    } catch (err) {
      this.setState({
        errorMsg: `Not a valid json`,
      });
      this.props.handleHasError(true);
      return;
    }

    const value = JSON.parse(items);
    this.props.handleHasError(false);
    this.props.handleNewValueChanged(value);
  }

  render() {
    const { valueSchema } = this.props;

    const { items, errorMsg } = this.state;
    const defaultValue = JSON.stringify(DEFAULT_ALGO);

    return (
      <div className="border rounded ml-4 bg-white p-2 text-sm text-gray-700">
        <>
          <div className="flex items-center justify-between text-xs">
            <div style={{ width: "90%" }}>ex. {defaultValue} </div>
            <ClickToCopyWrapper copyText={defaultValue}></ClickToCopyWrapper>
          </div>
          <TextAreaWithJsonCheck
            inputValue={items}
            handleInputChanged={this.handleItemsChanged}
          ></TextAreaWithJsonCheck>

          <div className="text-red-600">{errorMsg}</div>
        </>
      </div>
    );
  }
}

export default CstAlgorithmsControl;
